/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { CATEGORY_FILTER_OVERLAY_ID } from 'Component/CategoryFilterOverlay/CategoryFilterOverlay.config';
import { isCrawler, isSSR } from 'Util/Browser';

import './CategoryPage.style.scss';

export const renderMiscellaneous = (args, callback, instance) => {
    if (!instance.displayProducts()) {
        return null;
    }
    const {
        headerHeight, headerHidden, activeOverlay
    } = instance.props;

    const filtersHeight = instance.state;

    const { isStickyVisible, isNotInViewport } = instance.state;
    const height = instance.filterRef.current ? instance.filterRef.current.offsetHeight : 0;
    const topPosition = headerHidden ? 0 - height : headerHeight;
    return (
        <>
        <div block="CategoryPage" elem="ScrollToElementRef" ref={ instance.scrollToElementRef } />
        <aside
          block="CategoryPage"
          elem="TopPanel"
          ref={ instance.topPannelRef }
          style={ { minHeight: filtersHeight } }
        >
            <div
              block="CategoryPage"
              elem="InnerTopPanel"
              ref={ instance.filterRef }
              mods={ {
                  isStickyVisible: isStickyVisible || isNotInViewport,
                  isHidden: CATEGORY_FILTER_OVERLAY_ID === activeOverlay && isStickyVisible
              } }
              style={ { top: isStickyVisible || isNotInViewport ? topPosition : null } }
            >
                <div
                  block="CategoryPage"
                  elem="InnerTopPanelContainer"
                >
                    { instance.renderItemsCount() }
                    <div block="CategoryPage" elem="Filters">
                        <div
                          block="CategoryPage"
                          elem="LayoutWrapper"
                          mods={ { isPrerendered: isSSR() || isCrawler() } }
                        >
                            { instance.renderCategorySort() }
                        </div>
                        { instance.renderFilterButton() }
                    </div>
                    { instance.renderActiveFilters() }
                </div>
            </div>
        </aside>
        </>
    );
};

export default {
    'Route/CategoryPage/Component': {
        'member-function': {
            renderMiscellaneous
        }
    }
};
